export default "__VITE_ASSET__Cn6Wn3Qm__"